<template lang="pug">
v-container(fluid ma-0 px-0 py-1)
  v-row(
    no-gutters
    align="center"
    my-1
    class="tw-font-light tw-text-gray-darken-1  tw-text-sm tw-border tw-border-gray-lighten-3 tw-rounded-md"
    :class="{ 'tw-opacity-75': loading, 'tw-hidden': !display }"
  )
    v-col(class="tw-ml-2")
      span {{ item.email }}
    v-col
      span {{ item.role }}
    v-col
      span {{ $moment(item.created_at).format('DD-MM-YYYY') }}
    v-col(cols="1" class=" tw-text-right pr-2")
      v-btn(
        icon
        @click="deleteInvitation"
        :disabled="loading"
        small
        elevation="0"
        color="secondary"
      )
        v-icon mdi-trash-can
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
      display: true,
    };
  },
  methods: {
    deleteInvitation() {
      this.loading = true;
      this.$store
        .dispatch('team/deleteInvitation', this.item.id)
        .then((response) => {
          this.$store.dispatch('team/getInvitations').then(() => {
            this.display = false;
            this.loading = false;
          });
        })
        .catch((error) => {
          this.$store.commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
